import {useGetAndSet} from "./useGetAndSet";
import {createSetTotalsDataAction} from "../actions/dataActions";

export const useTotalsData = (params, dataFresh) => {
    return useGetAndSet("homepagetotal", params, createSetTotalsDataAction, dataFresh);
}